import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-prodcut-composition',
  templateUrl: './prodcut-composition.component.html',
  styleUrls: ['./prodcut-composition.component.css']
})
export class ProdcutCompositionComponent implements OnInit {

  form: any | FormGroup
  cid:any
  paramData:any = []
  productCompositionData: any = []
  imgUrl1 = ''
  imgUrl2 = ''
  file1: File | undefined;
  file2: File | undefined;
  singleproductCompositionData: any= []
  deleteProductCompositionId = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  first: number = 0;
  tableSize: number = 10;
  products:any = []
  uomData: any = []
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllUomMaster()
    this.generic_service.getAllProducts().subscribe(
      (res:any)=>{
        this.products = res.response
      }
    )
    this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
    this.form = this.fb.group({
      productName: [''],
      description: [''],
      productCompositionIngList:this.fb.array([]),
    })
    this.addInfoObject()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
  }

  get paramArr(){
    return this.form.get('productCompositionIngList') as FormArray;
  }

  paramObject(){
    return this.fb.group({
      "name": [''],
      "qty": [''],
      "uom": [''],
      "price": ['']
    })
   }
  
   addInfoObject(){
    // this.infoArr.clear()
    this.paramArr.push(this.paramObject())
   }

   removeParamObject(index: number){
    this.paramArr.removeAt(index)
   }

   getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

   addProductComposition(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "productName": String(this.form.get('productName').value),
      "productCompositionIngList": this.form.get('productCompositionIngList').value,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.addProductComposition(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
        this.cancelModel()
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllProductComposition(pageNumber:any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllProductComposition(pageNumber,recordsPerPage).subscribe(
      (response:any)=> {
        console.log(response)
        this.productCompositionData = response.response.productCompositionList
        this.totalRecords = response.response.totalRecords
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getProductCompositionById(id:any){
    this.generic_service.getProductCompositionById(id).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleproductCompositionData = []
        this.singleproductCompositionData.push(res.response)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  deleteUom(id:any){
    this.deleteProductCompositionId = id
  }

  deleteProductComposition(){
    this.generic_service.deleteProductComposition(this.deleteProductCompositionId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
        this.toastr.success(res.message)
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }


  searchKey:any = ""


  getProductCompositionByWildSearch(pageNumber: any,recordsPerPage: any){
    console.log(this.searchKey)
    if(this.searchKey != ""){
      this.isLoading = true

      this.generic_service.getProductCompositionByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.productCompositionData = response.response.productCompositionList
          this.totalRecords = response.response.totalRecords
          this.isLoading = false

        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
    }
  }

  refreshSearch(){
    this.searchKey = ""
    this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
  }

}
